import { useQuery } from '@tanstack/react-query';
import { fetchBillingStatus } from '../api/billingApi';

export default function useBillingStatus() {
    return useQuery({
        queryKey: ['billingStatus'],
        queryFn: fetchBillingStatus,
        staleTime: 30 * 1000,
    });
}
